import LoginOtpContainer from "./LoginOtpContainer";
import LoginOtpStore from "./LoginOtpStore";
export default LoginOtpStore(LoginOtpContainer);